// src/services/apis/tmdbApi.js

const tmdbApi = (apiClient) => ({
  searchMoviesOrTvShows: async (params) => {
    const response = await apiClient.get('/Stream/Tmdb/SearchMoviesOrTvShows', { params });
    return response.data;
  },
  getStreamingLinks: async (params) => {
    const response = await apiClient.get('/Stream/Tmdb/GetStreamingLinks', { params });
    return response.data;
  },
  GetSeasonsAndEpisodes: async (tmdbId) => {
    const response = await apiClient.get('/Stream/Tmdb/GetSeasonsAndEpisodes', { params: { tmdbId } });
    return response.data;
  },
});

export default tmdbApi;
